<template>
	<v-row align="center" justify="center">
		<v-col cols="12" sm="8" md="4">
			<v-progress-linear :indeterminate="true" color="secondary"></v-progress-linear>
		</v-col>
	</v-row>
</template>
<script>
	export default {
		created() {
			this.$store.dispatch('destroyToken')
		}
	}
</script>
